import { render, staticRenderFns } from "./OnlinePaymentConfigs.vue?vue&type=template&id=f5975028&scoped=true&"
import script from "./OnlinePaymentConfigs.vue?vue&type=script&lang=js&"
export * from "./OnlinePaymentConfigs.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePaymentConfigs.vue?vue&type=style&index=0&id=f5975028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5975028",
  null
  
)

export default component.exports